//页面中js/css文件处理

// 页面中是否包含某个js
function isInclude(name) {
	var js = /js$/i.test(name);
	var es = document.getElementsByTagName(js ? 'script' : 'link');
	for (var i = 0; i < es.length; i++) if (es[i][js ? 'src' : 'href'].indexOf(name) != -1) return true;
	return false
}

module.exports={
	isInclude:isInclude,
}



//////////////////
// WEBPACK FOOTER
// ./src/module/helper/file.js
// module id = 18
// module chunks = 0